import { NativeSelect } from "lib/miolo";
import type { MenuProvided } from "react-instantsearch-core";
import { connectMenu } from "react-instantsearch-dom";

const GovernmentOwnershipMenu = connectMenu<MenuProvided>(({ items, refine, currentRefinement }) => {
  return (
    <div className="space-y-4 font-aeonik font-normal">
      <h3 className="text-base font-bold uppercase tracking-wide text-zinc-500">Governo como Sócio</h3>

      <NativeSelect value={currentRefinement || ""} onChange={(event) => refine(event.currentTarget.value || "")}>
        <option value="">{currentRefinement === null ? "Selecionar filtro" : "Limpar filtro"}</option>

        {items.map((item) => {
          return (
            <option key={item.label} value={item.label}>
              {item.label === "true" ? "Qualquer participação" : "Sem participação"}
            </option>
          );
        })}
      </NativeSelect>
    </div>
  );
});

export default function GovernmentOwnership() {
  return <GovernmentOwnershipMenu attribute="isGovernmentAShareholder" />;
}
